import { render, staticRenderFns } from "./Navbar.Bottom.vue?vue&type=template&id=6346ae4f&scoped=true&"
import script from "./Navbar.Bottom.vue?vue&type=script&lang=js&"
export * from "./Navbar.Bottom.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.Bottom.vue?vue&type=style&index=0&id=6346ae4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346ae4f",
  null
  
)

export default component.exports